import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";
import { selectSearchText } from "../../../store/massiveDocumentCreate/selectors/selectSearchText";
import { setSearchText } from "../../../store/massiveDocumentCreate";

export const UsersSearchBar = () => {
  const dispatch = useDispatch();
  const searchText = useSelector(selectSearchText);
  return (
    <IonSearchbar
      value={searchText}
      onIonChange={({ detail: { value = "" } }) => {
        dispatch(setSearchText(value));
      }}
      debounce={700}
      placeholder={"Buscar usuario..."}
      autocomplete="off"
    />
  );
};
